export class ManifestarNotaFiscalEntradaDialogData {
  numeroNota = '';
  idTipoEventoManifestacaoAtual: number | null = null;
}
